"use strict";

require("core-js/modules/es6.array.for-each");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.map");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var events_1 = require("events");

var registrar_connector_1 = require("./registrar.connector");

var twilsock_connector_1 = require("./twilsock.connector");
/**
 * Provides an interface to the ERS registrar
 */


var Registrar =
/*#__PURE__*/
function (_events_1$EventEmitte) {
  _inherits(Registrar, _events_1$EventEmitte);

  /**
   * Creates the new instance of registrar client
   */
  function Registrar(productId, transport, twilsock, config) {
    var _this;

    _classCallCheck(this, Registrar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Registrar).call(this));
    _this.config = config;
    _this.connectors = new Map();

    var platform = _this.detectPlatform();

    _this.connectors.set('gcm', new registrar_connector_1.RegistrarConnector('gcm', {
      protocolVersion: 3,
      productId: productId,
      platform: platform
    }, transport, config));

    _this.connectors.set('fcm', new registrar_connector_1.RegistrarConnector('fcm', {
      protocolVersion: 3,
      productId: productId,
      platform: platform
    }, transport, config));

    _this.connectors.set('apn', new registrar_connector_1.RegistrarConnector('apn', {
      protocolVersion: 4,
      productId: productId,
      platform: platform
    }, transport, config));

    _this.connectors.set('twilsock', new twilsock_connector_1.TwilsockConnector({
      productId: productId,
      platform: platform
    }, twilsock, config));

    _this.connectors.get('twilsock').on('transportReady', function (state) {
      return _this.emit('transportReady', state);
    });

    return _this;
  }
  /**
   *  Sets notification ID.
   *  If new URI is different from previous, it triggers updating of registration for given channel
   *
   *  @param {string} channelType channel type (apn|gcm|fcm|twilsock)
   *  @param {string} notificationId The notification ID
   */


  _createClass(Registrar, [{
    key: "setNotificationId",
    value: function setNotificationId(channelType, notificationId) {
      this.connector(channelType).setNotificationId(notificationId);
    }
    /**
     * Subscribe for given type of message
     *
     * @param {String} messageType Message type identifier
     * @param {String} channelType Channel type, can be 'twilsock', 'gcm' or 'fcm'
     * @public
     */

  }, {
    key: "subscribe",
    value: function subscribe(messageType, channelType) {
      return this.connector(channelType).subscribe(messageType);
    }
    /**
     * Remove subscription
     * @param {String} messageType Message type
     * @param {String} channelType Channel type (twilsock or gcm/fcm)
     */

  }, {
    key: "unsubscribe",
    value: function unsubscribe(messageType, channelType) {
      return this.connector(channelType).unsubscribe(messageType);
    }
  }, {
    key: "updateToken",
    value: function updateToken(token) {
      this.connectors.forEach(function (connector) {
        return connector.updateToken(token);
      });
    }
    /**
     * @param {String} type Channel type
     * @throws {Error} Error with description
     */

  }, {
    key: "connector",
    value: function connector(type) {
      var connector = this.connectors.get(type);

      if (!connector) {
        throw new Error("Unknown channel type: ".concat(type));
      }

      return connector;
    }
    /**
     * Returns platform string limited to max 128 chars
     */

  }, {
    key: "detectPlatform",
    value: function detectPlatform() {
      var platform = '';

      if (typeof navigator !== 'undefined') {
        platform = 'unknown';

        if (typeof navigator.product !== 'undefined') {
          platform = navigator.product;
        }

        if (typeof navigator.userAgent !== 'undefined') {
          platform = navigator.userAgent;
        }
      } else {
        platform = 'web';
      }

      return platform.substring(0, 128);
    }
  }]);

  return Registrar;
}(events_1.EventEmitter);

exports.Registrar = Registrar;